import apiClient from '../client';
import type { RewardClaimSchema, WithPublicUserData, WithRewardSchema } from '@appTypes';

// Rewards Claims API
export type { RewardClaimSchema, WithPublicUserData, WithRewardSchema } from '@appTypes';

type ClaimWithUserAndReward = WithRewardSchema<WithPublicUserData<RewardClaimSchema>>;

/**
 * Fetch pending reward claims (non-paginated)
 */
export async function fetchPendingRewardClaims(): Promise<{ [key: string]: ClaimWithUserAndReward } | undefined> {
  const response: any = await apiClient.get('/fidelity/rewards-claims', {
    params: { paginated: false, status: 'Pending' },
  });
  return response.data;
}

/**
 * Fetch paginated reward claims
 */
export async function fetchPaginatedRewardClaims(params?: { lastDocumentId?: string }): Promise<{ data: { [key: string]: ClaimWithUserAndReward }; lastDocumentId?: string } | undefined> {
  const response: any = await apiClient.get('/fidelity/rewards-claims', {
    params: { paginated: true, lastDocumentId: params?.lastDocumentId },
  });
  return { data: response.data, lastDocumentId: response.lastDocumentId };
}

/**
 * Fetch paginated pending reward claims
 */
export async function fetchPaginatedPendingRewardClaims(params?: { lastDocumentId?: string }): Promise<{ data: { [key: string]: ClaimWithUserAndReward }; lastDocumentId?: string } | undefined> {
  const response: any = await apiClient.get('/fidelity/rewards-claims', {
    params: { paginated: true, lastDocumentId: params?.lastDocumentId, status: 'Pending' },
  });
  return { data: response.data, lastDocumentId: response.lastDocumentId };
}

/**
 * Validate a reward claim
 */
export async function validateRewardClaim(params: { rewardClaim: ClaimWithUserAndReward }): Promise<void> {
  await apiClient.post(`/fidelity/rewards-claims/${params.rewardClaim.rewardClaimId}/validate`, {
    rewardClaim: params.rewardClaim,
  });
}

/**
 * Reject a reward claim
 */
export async function rejectRewardClaim(params: {
  rewardClaim: ClaimWithUserAndReward;
  reason: { [key: string]: string };
}): Promise<void> {
  await apiClient.post(`/fidelity/rewards-claims/${params.rewardClaim.rewardClaimId}/reject`, {
    rewardClaim: params.rewardClaim,
    reason: params.reason,
  });
}
